function showTable() {
    var btnShowTablebtnShowTable = "";
    btnShowTablebtnShowTable = document.getElementById("btnShowTable");

    if (btnShowTablebtnShowTable) {
        let btnShowHide = document.querySelector("button[data-show='show']");

        if (btnShowHide.ariaExpanded === 'true') {
            btnShowHide.ariaExpanded = 'false';
            $(document.querySelector("div[data-show='content']")).slideUp("slow");

            btnShowHide.innerText = 'VER MÁS';

        } else {
            btnShowHide.ariaExpanded = 'true';
            $(document.querySelector("div[data-show='content']")).slideDown("slow");
            btnShowHide.innerText = 'VER MENOS';
        }
    }
}